import { Layout, Profile } from './profile';

const PROFILE_LIST_URL = 'https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0.*/dist/profiles';

const _jsonCache = new Map<string, Promise<{ [id: string]: any }>>();
function fetchJSON(url: string): Promise<{ [id: string]: any }> {
	let promise = _jsonCache.get(url);
	if (!promise) {
		promise = _fetchJSON(url);
		_jsonCache.set(url, promise);
	}
	return promise;
}

async function _fetchJSON(url: string): Promise<{ [id: string]: any }> {
	return await (await fetch(url)).json();
}

export async function fetchProfile(profiles: string[], defaultProfile?: string): Promise<Profile> {
	// Get the list of profiles
	const supportedProfilesList = await fetchJSON(PROFILE_LIST_URL + '/profilesList.json');

	// Find the relative path to the first requested profile that is recognized
	let match: any;
	profiles.some(profileId => {
		const supportedProfile = supportedProfilesList[profileId];
		if (supportedProfile) {
			match = {
				profileId,
				profilePath: `${PROFILE_LIST_URL}/${supportedProfile.path}`,
				deprecated: !!supportedProfile.deprecated,
			};
		}
		return !!match;
	});

	if (!match) {
		if (!defaultProfile) {
			throw new Error('No matching profile name found');
		}

		const supportedProfile = supportedProfilesList[defaultProfile];
		if (!supportedProfile) {
			throw new Error(`No matching profile name found and default profile "${defaultProfile}" missing.`);
		}

		match = {
			profileId: defaultProfile,
			profilePath: `${PROFILE_LIST_URL}/${supportedProfile.path}`,
			deprecated: !!supportedProfile.deprecated,
		};
	}

	return (await fetchJSON(match.profilePath)) as Profile;
}

export function getAssetURL(profile: Profile, handedness: XRHandedness | 'any'): string | undefined {
	const entries = Object.entries(profile.layouts);
	if (entries.length === 0) return;

	let layout: Layout | undefined;

	if (handedness === 'any') {
		layout = entries[0][1];
	} else {
		layout = profile.layouts[handedness];
	}

	if (!layout) return;
	return `${PROFILE_LIST_URL}/${profile.profileId}/${layout.assetPath}`;
}
